var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.config)?_c('div',{attrs:{"id":"app"}},[_c(_vm.page,{tag:"component",attrs:{"config":_vm.config,"phases":_vm.phases,"video":_vm.video},on:{"action":_vm.onAction}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }